/**
 * lex.ivoliq Rechtstexte (Sprint S3, Aug 2026) — Impressum · Datenschutz · AGB
 * Eigene lex-Fassungen mit Kanzlei-Passagen (Haus-StB, Zwei-Verträge-Modell, Pilot).
 * Hinweis Betreiber: anwaltliche Endprüfung vor Go-Live (Roadmap B3/L1).
 */
import { Link, useParams } from "react-router-dom";
import "@/styles/lex.css";

const H = ({ children }) => <h2 className="lex-serif text-xl font-semibold mt-8 mb-3" style={{ color: "#0A1128" }}>{children}</h2>;
const P = ({ children }) => <p className="text-sm text-slate-600 leading-relaxed mb-3">{children}</p>;

const IMPRESSUM = (
  <>
    <H>Impressum</H>
    <P>Angaben gemäß § 5 ECG, § 25 MedienG:</P>
    <P><strong>ivoliq GmbH</strong><br />Firmenbuchnummer: FN 680579 b · UID: ATU83347308<br />
      Geschäftsführung: Wilhelm Wagner · E-Mail: office@ivoliq.io</P>
    <P><strong>lex.ivoliq</strong> ist ein Produkt der ivoliq GmbH: eine Buchhaltungs- und
      Kanzlei-Software für Rechtsanwältinnen und Rechtsanwälte in Österreich.</P>
    <H>Steuerliche Betreuung (Kanzlei-Passus)</H>
    <P>Die steuerliche Vertretung (Umsatzsteuervoranmeldungen, Steuererklärungen, Fristenwahrung)
      erbringt nicht die ivoliq GmbH, sondern die mit Ihnen mandatierte Steuerberatungskanzlei
      (Vorbehaltsaufgabe nach WTBG 2017). Die ivoliq GmbH erbringt ausschließlich Softwareleistungen.</P>
  </>
);

const DATENSCHUTZ = (
  <>
    <H>Datenschutzerklärung lex.ivoliq</H>
    <P>Verantwortlicher für die Softwareplattform: ivoliq GmbH (siehe <Link to="/lex-impressum" className="underline">Impressum</Link>).
      Diese Erklärung ergänzt die allgemeine <Link to="/privacy" className="underline">ivoliq-Datenschutzerklärung</Link> um lex-spezifische Verarbeitungen.</P>
    <H>1. Weitergabe an Ihre Steuerberatungskanzlei</H>
    <P>Kern von lex.ivoliq ist die Betreuung durch Ihre Steuerberatungskanzlei. Dafür erhält die von
      Ihnen bevollmächtigte Kanzlei Zugriff auf Ihre in der Software geführten Geschäftsdaten
      (Honorarnoten, Belege, Umsatz-/Steuerdaten, Stammdaten, Fristenstatus). Rechtsgrundlage:
      Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) auf Basis Ihres Steuerberatungsmandats und der
      im Onboarding erteilten bzw. bestätigten Vollmacht. Die Kanzlei ist für das Steuermandat
      eigenständige Verantwortliche im Sinne der DSGVO.</P>
    <H>2. Rollen &amp; Auftragsverarbeitung</H>
    <P>Die ivoliq GmbH verarbeitet Ihre Daten als Auftragsverarbeiterin (Art. 28 DSGVO) für Sie
      (Hosting, Software) — Grundlage ist die bei der Registrierung akzeptierte AVV. Mit der
      betreuenden Kanzlei besteht eine gesonderte datenschutzrechtliche Vereinbarung.</P>
    <H>3. Mandats- und Honorardaten Ihrer Kanzleikunden</H>
    <P>In Honorarnoten verarbeitete Empfängerdaten (Kanzleien als Ihre Kunden) verarbeiten Sie als
      Rechtsanwältin/Rechtsanwalt in eigener Verantwortung; die anwaltliche Verschwiegenheit
      (§ 9 RAO) bleibt unberührt.</P>
    <H>4. E-Mails, Analyse, Speicherdauer</H>
    <P>Transaktionale E-Mails (Einladungen, Freigabe-Links, Versandbestätigungen) versenden wir über
      Brevo (Sendinblue GmbH, EU). Die Plattform nutzt ausschließlich cookielose, serverseitige
      1st-Party-Nutzungsstatistik ohne Tracking-Cookies. Aufbewahrung gemäß § 132 BAO (7 Jahre) für
      abgabenrechtlich relevante Daten. Ihre Betroffenenrechte (Auskunft, Löschung, Übertragbarkeit,
      Beschwerde bei der Datenschutzbehörde) richten Sie an office@ivoliq.io.</P>
  </>
);

const AGB = (
  <>
    <H>Nutzungsbedingungen lex.ivoliq (AGB)</H>
    <P>Diese Bedingungen gelten für die Nutzung der Software lex.ivoliq der ivoliq GmbH und ergänzen
      die allgemeinen <Link to="/terms" className="underline">ivoliq-AGB</Link>. Angebot ausschließlich
      für Unternehmer (B2B), insbesondere Rechtsanwältinnen und Rechtsanwälte in Österreich.</P>
    <H>1. Zwei-Verträge-Modell</H>
    <P>(a) Mit der ivoliq GmbH schließen Sie einen <strong>Softwarevertrag</strong> (Bereitstellung
      der Plattform: Honorarnoten, Belege, UVA-Vorbereitung, Fristenkalender, Kanzlei-Portal).
      (b) Die <strong>steuerliche Beratung und Vertretung</strong> erfolgt aufgrund eines gesonderten
      Mandats zwischen Ihnen und der Steuerberatungskanzlei. Die ivoliq GmbH erbringt keine
      Steuerberatung und schuldet keine steuerlichen Arbeitserfolge.</P>
    <H>2. Pilot-Phase</H>
    <P>Der Zugang erfolgt derzeit auf persönliche Einladung (Pilot). Während der Pilot-Phase ist die
      Nutzung unentgeltlich; eine spätere Bepreisung wird mit angemessener Frist angekündigt,
      Bestandskonditionen für Pilot-Teilnehmer werden gesondert mitgeteilt.</P>
    <H>3. Mitwirkungspflichten</H>
    <P>Sie sind verantwortlich für die Richtigkeit und Vollständigkeit der erfassten Daten sowie für
      die fristgerechte Bestätigung angeforderter Freigaben (z. B. Honorarnoten, Perioden-Reviews).
      Steuerliche Fristen wahrt die Kanzlei auf Basis der von Ihnen bereitgestellten Daten.</P>
    <H>4. Haftung, Verfügbarkeit, Daten</H>
    <P>Die ivoliq GmbH haftet für Softwarefehler im Rahmen der allgemeinen ivoliq-AGB; für steuerliche
      Beratungsleistungen haftet ausschließlich die mandatierte Kanzlei im Rahmen ihrer
      Berufshaftpflicht. Bei Vertragsende erhalten Sie Ihre Daten in einem gängigen Format
      (Export); gesetzliche Aufbewahrungspflichten bleiben unberührt.</P>
  </>
);

const SECTIONS = {
  impressum: { title: "Impressum", body: IMPRESSUM },
  datenschutz: { title: "Datenschutz", body: DATENSCHUTZ },
  agb: { title: "AGB", body: AGB },
};

export default function LexLegal({ section }) {
  const params = useParams();
  const key = section || params.section || "impressum";
  const s = SECTIONS[key] || SECTIONS.impressum;
  return (
    <div className="lex-theme min-h-screen" style={{ background: "#FDFCFB" }} data-testid={`lex-legal-${key}`}>
      <header className="px-6 py-5" style={{ background: "#0A1128" }}>
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="lex-serif text-xl font-semibold text-white">lex<span style={{ color: "#C5A059" }}>.</span>ivoliq</Link>
          <nav className="flex gap-4 text-xs text-slate-300">
            {Object.entries(SECTIONS).map(([k, v]) => (
              <Link key={k} to={`/lex-${k}`} className={`underline hover:text-white ${k === key ? "text-white font-semibold" : ""}`}>{v.title}</Link>
            ))}
          </nav>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="lex-goldline mb-2" style={{ width: 48, height: 3, background: "#C5A059" }} />
        {s.body}
        <p className="lex-mono text-xs text-slate-400 mt-10">Stand: August 2026 · ivoliq GmbH · ATU83347308</p>
      </main>
    </div>
  );
}
